import React, { useEffect, useCallback, useState, useRef } from 'react';
import SearchCondition from './components/search_condition/index';
import AdjustmentDataResult from './components/adjustment_data_result/index';
import { useLocation, history } from 'umi';
import { useDispatch } from 'dva';
import qs from 'qs';
import webStorage from '@/utils/storageManager';
import dayjs from 'dayjs';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [modification, setModification] = useState({});
  const { query, pathname } = location;
  const {
    memberCode,
    mobile,
    type,
    // approvalState,
    pageNum = '1',
    pageSize = '10',
    time,
  } = query;

  const DICTOBJ = webStorage.get('DICTOBJ');
  const { MANUAL_OPERATION_APPROVE_STATE } = DICTOBJ || [];
  const { MANUAL_OPERATION_TYPE } = DICTOBJ || [];
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: '1',
      })}`,
    );
  };

  // 获取列表
  const fetchData = useCallback(() => {
    const values = {
      memberCode: memberCode || null,
      mobile: mobile || null,
      type: type || null,
      // approvalState: approvalState || null,
      pageNum,
      pageSize,
      time,
      searchCount: false,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'adjustmentData/getViewList',
      payload: {
        values,
      },
    });
  }, [
    dispatch,
    pageNum,
    pageSize,
    mobile,
    memberCode,
    type,
    // approvalState,
    time,
  ]);

  const fetchDataNum = useCallback(() => {
    dispatch({
      type: 'adjustmentData/getViewListNum',
      payload: {
        values: {
          memberCode: memberCode || null,
          mobile: mobile || null,
          type: type || null,
          // approvalState: approvalState || null,
          pageNum,
          pageSize,
          time,
          searchCount: true,
        },
      },
    });
  }, [
    dispatch,
    pageNum,
    pageSize,
    mobile,
    memberCode,
    type,
    // approvalState,
    time,
  ]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    fetchDataNum();
  }, [fetchDataNum]);

  return (
    <div
      data-log={JSON.stringify({
        oid: 'page_manual_adjustment_member_adjustment_record_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <SearchCondition
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        // setModification={setModification}
        restClick={handleRestClick}
        MANUAL_OPERATION_APPROVE_STATE={MANUAL_OPERATION_APPROVE_STATE}
        MANUAL_OPERATION_TYPE={MANUAL_OPERATION_TYPE}
      ></SearchCondition>
      <AdjustmentDataResult
        modification={modification}
        setModification={setModification}
        setPageData={handlePageChange}
        pagination={{
          pageNum,
          pageSize,
        }}
      ></AdjustmentDataResult>
    </div>
  );
};
